import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const Card = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  width: "100%",
}));

export const Image = styled("img")(() => ({
  padding: "16px",
  width: "60px",
  height: "60px",
}));

export const CardInfosWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  width: "100%",
  padding: "8px",
}));

export const CardIcon = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "hasCertification";
  },
})<{
  hasCertification?: boolean;
}>(({ hasCertification }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "row-reverse",
  justifyContent: "center",
  padding: hasCertification ? "16px 12px" : "16px 12px",
}));

export const Details = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}));

export const PlainText = styled("div")(() => ({
  margin: 0,
  fontSize: "14px",
  fontWeight: 400,
  fontFamily: "Manrope",
  fontStyle: "normal",
  letterSpacing: "0.25px",
  lineHeight: "20px",
}));

interface ISubTitle {
  isEmpty?: boolean;
  isOneLine?: boolean;
}

export const SubTitle = styled(PlainText, {
  shouldForwardProp(propName) {
    return propName !== "isEmpty" && propName !== "IsOneLine";
  },
})(({ isEmpty, isOneLine }: ISubTitle) => ({
  overflow: "hidden",
  textOverflow: "ellipsis",

  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: isEmpty ? 400 : 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  color: isEmpty ? colors.gray400 : colors.gray500,
  ...(isOneLine && {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "180px",
  }),
}));

interface UnavailableTextProps {
  isAvailable?: boolean;
}

export const UnavailableText = styled("span", {
  shouldForwardProp(propName) {
    return propName !== "isAvailable";
  },
})<UnavailableTextProps>(({ isAvailable = false }) => ({
  overflow: "hidden",
  color: !isAvailable ? colors.error600 : colors.warning600,
  textOverflow: "ellipsis",

  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
}));

export const CertificationsTypeContainer = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  position: "absolute",
  left: "35px",
}));

export const CertificationsTypeWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  gap: "16px",
}));
